import type { RefObject } from 'react';
import { useLingui } from '@lingui/react/macro';

import { MULTI_CONTACT_ROUTE } from '@rover/components/src/shortlist/constants';
import { Button, Flex } from '@rover/kibble/core';
import type { MarginSystemProps } from '@rover/kibble/core/styledSystemPropTypes';

import type { PagePosition, ShortlistLayout } from './types';

type Props = {
  layout: ShortlistLayout;
  pagePosition: PagePosition;
  margins: MarginSystemProps;
  continueRef: RefObject<HTMLElement | null>;
  viewListRef: RefObject<HTMLElement | null>;
  onContinue: () => void;
  onViewList: () => void;
};

const ShortlistContinueButtons = ({
  layout,
  pagePosition,
  margins,
  continueRef,
  viewListRef,
  onContinue,
  onViewList,
}: Props): JSX.Element => {
  const { t } = useLingui();
  const isHeader = layout === 'header';
  const isSingleButton = isHeader || layout === 'legacy';

  const continueButton = (
    <Button
      variant="primary"
      href={MULTI_CONTACT_ROUTE}
      onPress={onContinue}
      width={isHeader ? undefined : '100%'}
      px={isHeader ? '6x' : undefined}
      maxWidth={isHeader ? '250px' : undefined}
      {...(isSingleButton ? margins : {})}
      data-testid={`continue-to-contact-button-${pagePosition}`}
      webProps={{ ref: continueRef }}
    >
      {isHeader ? t`Continue to contact` : t`Continue to contact form`}
    </Button>
  );

  if (isSingleButton) {
    return continueButton;
  }

  return (
    <Flex flexDirection="column" gap="3x" width="100%" {...margins}>
      {continueButton}
      <Button
        variant="secondary"
        fullWidth
        onPress={onViewList}
        aria-haspopup="dialog"
        data-testid={`view-contact-list-button-${pagePosition}`}
        webProps={{ ref: viewListRef }}
      >
        {t`View contact list`}
      </Button>
    </Flex>
  );
};

export default ShortlistContinueButtons;
